// extracted by mini-css-extract-plugin
export default {"sucess":"StudentForm_sucess__7CnKR","succiessicoj":"StudentForm_succiessicoj__tSAVt","xtxt":"StudentForm_xtxt__BFZ1g"};